import axios from '../utils/axios';

export const listNotifications = async ({ page = 1, limit = 50, unreadOnly = false } = {}) => {
  const params = new URLSearchParams();
  params.set('page', page);
  params.set('limit', limit);
  if (unreadOnly) params.set('unread_only', 'true');
  const { data } = await axios.get(`/api/my-pages/notifications?${params.toString()}`);
  return data;
};

export const getUnreadCount = async () => {
  const { data } = await axios.get('/api/my-pages/notifications/unread-count');
  return data;
};

export const markNotificationRead = async (id) => {
  const { data } = await axios.put(`/api/my-pages/notifications/${id}/read`);
  return data;
};

export const markAllNotificationsRead = async () => {
  const { data } = await axios.put('/api/my-pages/notifications/read-all');
  return data;
};

export const listNotificationSettings = async () => {
  const { data } = await axios.get('/api/my-pages/notifications/settings');
  return data;
};

export const updateNotificationSettings = async (updates) => {
  const { data } = await axios.put('/api/my-pages/notifications/settings', updates);
  return data;
};
